import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { DOCUMENT } from '@angular/common';


@Injectable()
export class ExternalUrlResolver implements Resolve<void> {
  constructor(@Inject(DOCUMENT) private document: any) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void {
    this.document.location.href = (route.data as any).externalUrl;
  }
}
